import React, { lazy, Suspense, useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import {
    SecondAds,
    FirstAds,
    MobileUnderCalAds
} from "../../Ads";
import SharedHelmet from "../Helmet";
const BodyFatTable = lazy(() => import("./BodyFatTable"));
const TITLE = 'حساب نسبة الدهون في الجسم';
const DESCRIPTION = 'تقوم هذه الحاسبة ب حساب نسبة الدهون في الجسم  و حساب نسبة الدهون الطبيعية للرجال و للنساء ونسبة الدهون الثلاثية الطبيعية  .';
const KEYWORDS = 'نسبة الدهون في الجسم, إحسب نسبة الدهون في الجسم , حساب نسبة الدهون , نسبة الدهون الطبيعية , قياس نسبة الدهون, اعرف نسبة الدهون, حاسبة نسبة الدهون للرجال و للنساء,  التغذية السليمة,حساب،نسبة،الدهون،في،الجسم,،حساب،نسبة،الدهون,،حساب،كتلة،الدهون , قياس نسبة الدهون في الجسم  ';
const OG_URL = 'https://do-calculate.com/calculator/ar/bodyfat/';
function BodyFatCalculator() {
    const [weight, setWeight] = useState("");
    const [height, setHeight] = useState("");
    const [age, setAge] = useState("");
    const [gender, setGender] = useState("");
    const [neckMeasurement, setNeckMeasurement] = useState("");
    const [waistMeasurement, setWaistMeasurement] = useState("");
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const [classification, setClassification] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const calculateBodyFatLocal = (weight, waistMeasurement, neckMeasurement, height, age, gender) => {
        try {
            const weightInches = weight * 0.393701;
            const waistInches = waistMeasurement * 0.393701;
            const neckInches = neckMeasurement * 0.393701;
            const heightInches = height * 0.393701;
            let bodyFatPercentage;
            if (gender.toLowerCase() === 'male') {
                bodyFatPercentage = (86.010 * Math.log10(waistInches - neckInches)) - (70.041 * Math.log10(heightInches)) + 36.76;
                bodyFatPercentage = bodyFatPercentage.toFixed(2);
                if (age >= 40) {
                    bodyFatPercentage = parseFloat(bodyFatPercentage) + 0.5;
                }
            } else if (gender.toLowerCase() === 'female') {
                bodyFatPercentage = (163.205 * Math.log10(waistInches + waistInches - neckInches)) - (97.684 * Math.log10(heightInches)) - 78.387;
                bodyFatPercentage = bodyFatPercentage.toFixed(2);
                if (age >= 40) {
                    bodyFatPercentage = parseFloat(bodyFatPercentage) + 0.5;
                }
            } else {
                throw new Error('Invalid gender. Only "male" and "female" are allowed.');
            }
            let bodyFatCategory = null;
            if (gender.toLowerCase() === 'male') {
                if (bodyFatPercentage < 2) {
                    bodyFatCategory = 'Less than Essential Fat';
                    bodyFatPercentage = 0;
                } else if (bodyFatPercentage >= 2 && bodyFatPercentage <= 5) {
                    bodyFatCategory = 'Essential Fat';
                } else if (bodyFatPercentage > 5 && bodyFatPercentage <= 13) {
                    bodyFatCategory = 'Athletes';
                } else if (bodyFatPercentage > 13 && bodyFatPercentage <= 17) {
                    bodyFatCategory = 'Fitness';
                } else if (bodyFatPercentage > 17 && bodyFatPercentage <= 25) {
                    bodyFatCategory = 'Acceptable';
                } else if (bodyFatPercentage > 25) {
                    bodyFatCategory = 'Obese';
                }
            } else if (gender.toLowerCase() === 'female') {
                if (bodyFatPercentage >= 10 && bodyFatPercentage <= 13) {
                    bodyFatCategory = 'Essential Fat';
                } else if (bodyFatPercentage > 13 && bodyFatPercentage <= 20) {
                    bodyFatCategory = 'Athletes';
                } else if (bodyFatPercentage > 20 && bodyFatPercentage <= 24) {
                    bodyFatCategory = 'Fitness';
                } else if (bodyFatPercentage > 24 && bodyFatPercentage <= 32) {
                    bodyFatCategory = 'Acceptable';
                } else if (bodyFatPercentage > 32) {
                    bodyFatCategory = 'Obese';
                }
            }
            if (bodyFatCategory === null) {
                throw new Error('Unable to determine body fat category.');
            }
            const fatMass = ((bodyFatPercentage / 100) * weight).toFixed(2);
            const leanMass = (weight - fatMass).toFixed(2);
            let idealBodyFatPercentage = 0;
            if (gender.toLowerCase() === 'male') {
                if (age >= 20 && age < 25) {
                    idealBodyFatPercentage = 8.5;
                } else if (age >= 25 && age < 30) {
                    idealBodyFatPercentage = 10.5;
                } else if (age >= 30 && age < 35) {
                    idealBodyFatPercentage = 12.7;
                } else if (age >= 35 && age < 40) {
                    idealBodyFatPercentage = 13.7;
                } else if (age >= 40 && age < 45) {
                    idealBodyFatPercentage = 15.3;
                } else if (age >= 45 && age < 50) {
                    idealBodyFatPercentage = 16.4;
                } else if (age >= 50 && age < 55) {
                    idealBodyFatPercentage = 18.9;
                } else if (age >= 55) {
                    idealBodyFatPercentage = 20.9;
                }
            } else if (gender.toLowerCase() === 'female') {
                if (age >= 20 && age < 25) {
                    idealBodyFatPercentage = 17.7;
                } else if (age >= 25 && age < 30) {
                    idealBodyFatPercentage = 18.4;
                } else if (age >= 30 && age < 35) {
                    idealBodyFatPercentage = 19.3;
                } else if (age >= 35 && age < 40) {
                    idealBodyFatPercentage = 21.5;
                } else if (age >= 40 && age < 45) {
                    idealBodyFatPercentage = 22.2;
                } else if (age >= 45 && age < 50) {
                    idealBodyFatPercentage = 22.9;
                } else if (age >= 50 && age < 55) {
                    idealBodyFatPercentage = 25.2;
                } else if (age >= 55) {
                    idealBodyFatPercentage = 26.3;
                }
            }
            let bodyFatToLose = 0;
            if (age >= 20) {
                bodyFatToLose = ((bodyFatPercentage - idealBodyFatPercentage) / 100 * weight).toFixed(2);
            }
            const result = {
                bodyFatPercentage,
                fatMass,
                leanMass,
                bodyFatCategory,
                idealBodyFatPercentage,
                bodyFatToLose
            };
            return { result };
        } catch (error) {
            throw error;
        }
    };
    const handleWeightChange = (event) => {
        setWeight(event.target.value);
    };
    const handleHeightChange = (event) => {
        setHeight(event.target.value);
    };
    const handleAgeChange = (event) => {
        setAge(event.target.value);
    };
    const handleGenderChange = (event) => {
        setGender(event.target.value);
    };
    const handleNeckMeasurementChange = (event) => {
        setNeckMeasurement(event.target.value);
    };
    const handleWaistMeasurementChange = (event) => {
        setWaistMeasurement(event.target.value);
    };
    const calculateBodyFat = () => {
        setIsLoading(true);
        setError(null);
        setStatusCode(null);
        try {
            if (!weight || !height || !age || !gender || !neckMeasurement || !waistMeasurement) {
                setError("يُرجى إدخال جميع الحقول بالشكل الصحيح.");
                setStatusCode(400);
                setResult(null);
                return;
            }
            const weightNum = parseFloat(weight);
            const heightNum = parseFloat(height);
            const ageNum = parseInt(age);
            const neckNum = parseFloat(neckMeasurement);
            const waistNum = parseFloat(waistMeasurement);
            if (isNaN(weightNum) || isNaN(heightNum) || isNaN(ageNum) || isNaN(neckNum) || isNaN(waistNum)) {
                setError("يُرجى إدخال قيم صحيحة للأرقام.");
                setStatusCode(400);
                setResult(null);
                return;
            }
            const calculationResult = calculateBodyFatLocal(
                weightNum,
                waistNum,
                neckNum,
                heightNum,
                ageNum,
                gender
            );
            setResult(calculationResult.result);
            setClassification(calculationResult.result.bodyFatCategory);
            setStatusCode(200);
        } catch (error) {
            console.error(error);
            setError("حدث خطأ في الحساب. يُرجى التحقق من البيانات المدخلة.");
            setStatusCode(400);
            setResult(null);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div className="rtl">
            <SharedHelmet
                TITLE={TITLE}
                DESCRIPTION={DESCRIPTION}
                KEYWORDS={KEYWORDS}
                OG_URL={OG_URL}
            />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white  text-center  justify-content-center align-items-center" style={{ height: '35px' }}>
                        <h1 style={{ fontSize: '16px' }}>حساب نسبة الدهون في الجسم للرجال وللنساء</h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                تقوم حاسبة نسبة الدهون ب حساب نسبة الدهون في الجسم  و حساب نسبة الدهون الطبيعية للرجال و للنساء ونسبة الدهون الثلاثية الطبيعية ونسبة الدهون في الدم والتي هي عبارة عن النسبة المئوية من إجمالي وزن الجسم التي تمثل الدهون
                                <br />
                                تمكنك حاسبة نسبة الدهون في الجسم من حساب وقياس نسبة الدهون في الجسم باستخدام معادلات مختلفة مثل معادلة جاكسون وبولار (Jackson & Pollard). تعتبر حاسبة نسبة الدهون في الجسم مهمة في تقدير صحة الفرد ومستوى لياقة بدنه.
                                <br />
                                <hr />
                            </div>
                            <br />
                        </div>
                        <MobileUnderCalAds />
                        <div className="row">
                            <div className="col-sm-12 col-md-5 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    نسبة الدهون في الجسم
                                </div>
                                <hr />
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='height' className="form-label ms-2" >الطول</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="height"
                                        value={height}
                                        onChange={handleHeightChange}
                                        className="form-control ml-2"
                                        style={{ width: '100%' }}
                                        placeholder="175"
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text">سم</span>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='weightNumber' className="form-label ms-2">الوزن</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="weightNumber"
                                        value={weight}
                                        onChange={handleWeightChange}
                                        className="form-control ml-2"
                                        style={{ width: '90%' }}
                                        placeholder="65"
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text">كغ</span>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label htmlFor='age' className="form-label ms-2">العمر</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="age"
                                        value={age}
                                        onChange={handleAgeChange}
                                        className="form-control"
                                        style={{ width: '90%' }}
                                        placeholder="33"
                                        min="2"
                                    />
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label >الجنس</label>
                                    </b>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="gender"
                                            value="male"
                                            id="male"
                                            checked={gender === "male"}
                                            onChange={handleGenderChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="male">
                                            ذكر
                                        </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                        <input
                                            type="radio"
                                            name="gender"
                                            value="female"
                                            id="female"
                                            checked={gender === "female"}
                                            onChange={handleGenderChange}
                                            className="form-check-input"
                                        />
                                        <label className="form-check-label" htmlFor="female">
                                            أنثى
                                        </label>
                                    </div>
                                </div>
                                <br />
                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label className="form-label ms-2">قياس الخصر</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="waistMeasurement"
                                        value={waistMeasurement}
                                        onChange={handleWaistMeasurementChange}
                                        className="form-control"
                                        style={{ width: '90%' }}
                                        placeholder="90"
                                        min="2"
                                        max="20"
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text">سم</span>
                                    </div>
                                </div>
                                <br />                                <div className="form-group d-flex align-items-center">
                                    <b>
                                        <label className="form-label ms-2">قياس العنق</label>
                                    </b>
                                    <input
                                        type="number"
                                        id="neckMeasurement"
                                        value={neckMeasurement}
                                        onChange={handleNeckMeasurementChange}
                                        className="form-control"
                                        style={{ width: '90%' }}
                                        placeholder="47"
                                        min="2"
                                        max="20"
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text">سم</span>
                                    </div>
                                </div>
                                <br />
                                <hr />
                                <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={
                                    calculateBodyFat} disabled={isLoading}>
                                    {isLoading ? (
                                        <div className="spinner-border spinner-border-sm" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    ) : (
                                        'إحسب'
                                    )}
                                </button>
                            </div>
                            <div className="col-sm-12 col-md-7">
                                {result && (
                                    <div>
                                        <div className="alert alert-success">
                                            <h5>النتائج  : </h5>
                                        </div>
                                        <hr />
                                        <Suspense fallback={<div>Loading...</div>}>
                                            <BodyFatTable result={result} />
                                        </Suspense>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <br />
                                {statusCode === 400 && <div className="alert alert-warning"><b><u> حدث خطأ :</u></b> يُرجى إدخال جميع الحقول بالشكل الصحيح. </div>}
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList />
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">{TITLE}
                                :</div>
                            <div className="info-section-body">
                                <u><h2 style={{ fontSize: '16px' }}>ما هي نسبة الدهون في الجسم؟
                                </h2> </u>
                                نسبة الدهون في الجسم هي النسبة المئوية لكمية الدهون المخزنة في جسمك مقارنة بإجمالي وزنك. تتكون هذه الدهون من الدهون الحرة والدهون المخزنة في الأنسجة الدهنية المختلفة في الجسم. يمكن تصنيف نسبة الدهون إلى فئات مختلفة استنادًا إلى الصحة واللياقة البدنية العامة:
                                <ul>
                                    <li>
                                        نسبة الدهون الطبيعية: هذه هي النسبة الصحية للدهون في الجسم وتتراوح عادة بين 15% و20% للنساء وبين 10% و15% للرجال.
                                    </li>
                                    <li>
                                        نسبة الدهون الزائدة: إذا زادت نسبة الدهون عن هذه النسب القياسية، فإنها يمكن أن تزيد من مخاطر الإصابة بأمراض مثل السمنة وأمراض القلب والسكري.
                                    </li>
                                    <li>
                                        نقص نسبة الدهون: إذا كانت نسبة الدهون أقل من النسب القياسية، فإن ذلك يمكن أن يؤدي إلى مشاكل صحية مثل هشاشة العظام ونقص التغذية.
                                    </li>
                                </ul>
                                <u><h2 style={{ fontSize: '16px' }}> كيفية حساب نسبة الدهون في الجسم:
                                </h2> </u>
                                هناك العديد من الطرق المختلفة لقياس نسبة الدهون في الجسم، ومن أشهرها:
                                <ul>
                                    <li>
                                        استخدام حاسبة نسبة الدهون: يمكنك استخدام حاسبة نسبة الدهون على الإنترنت التي قمنا بتطويرها، حيث ستحتاج إلى إدخال بعض المعلومات مثل الوزن والارتفاع والعمر والجنس.
                                    </li>
                                    <li>
                                        استخدام جهاز قياس نسبة الدهون: يتوفر في الأسواق جهاز قياس نسبة الدهون الذي يستخدم تقنيات مثل الكهرباء البيوية لقياس نسبة الدهون في جسمك.
                                    </li>
                                    <li>
                                        القياس بواسطة المحترفين: يمكنك طلب المساعدة من محترفي اللياقة البدنية أو الأطباء لقياس نسبة الدهون في جسمك باستخدام أدوات خاصة.
                                    </li>
                                </ul>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}> كيف تعمل حاسبة نسبة الدهون في الجسم
                                    : </h2> </u>
                                <p>
                                    تعد هذه الحاسبة مناسبة للأشخاص العاديين الذين يرغبون في حساب نسبة الدهون في الجسم. يمكن استخدامها لحساب الدهون في الجسم بناءً على عدة مقاييس مثل الوزن وقياس الخصر وقياس الرقبة والطول والعمر والجنس.
                                    عند استخدام الحاسبة، يتعين على المستخدم إدخال قيم مثل الوزن، وقياس الخصر، وقياس الرقبة، والطول، والعمر، والجنس. ومن ثم، ستقوم الحاسبة بحساب النسبة المئوية للدهون في الجسم بناءً على المعادلات الموجودة في الكود.
                                </p>
                                بعد الحسابات، ستعيد الحاسبة النتائج التالية:
                                <br />
                                <ul>
                                    <li>
                                        النسبة المئوية للدهون في الجسم.
                                    </li>
                                    <li>
                                        كتلة الدهون.
                                    </li>
                                    <li>
                                        كتلة العضلات.
                                    </li>
                                    <li>
                                        تصنيف نسبة الدهون في الجسم بناءً على إرشادات ACE.
                                    </li>
                                    <li>
                                        النسبة المثلى للدهون في الجسم بناءً على العمر والجنس.
                                    </li>
                                    <li>
                                        كتلة الدهون المطلوب فقدها للوصول إلى النسبة المثلى للدهون في الجسم.
                                    </li>
                                </ul>
                                <hr />
                                <b>    نسب الدهون المثلى في الجسم وفقًا لـ Jackson & Pollard</b>
                                <div >
                                    <table >
                                        <thead >
                                            <tr>
                                                <th className="formula-header">العمر</th>
                                                <th className="formula-header">إناث</th>
                                                <th className="formula-header">ذكور</th>
                                            </tr>
                                            <tr>
                                                <td>20</td>
                                                <td>17.7%</td>
                                                <td>8.5%</td>
                                            </tr>
                                            <tr>
                                                <td>25</td>
                                                <td>18.4%</td>
                                                <td>10.5%</td>
                                            </tr>
                                            <tr>
                                                <td>30</td>
                                                <td>19.3%</td>
                                                <td>12.7%</td>
                                            </tr>
                                            <tr>
                                                <td>35</td>
                                                <td>21.5%</td>
                                                <td>13.7%</td>
                                            </tr>
                                            <tr>
                                                <td>40</td>
                                                <td>22.2%</td>
                                                <td>15.3%</td>
                                            </tr>
                                            <tr>
                                                <td>45</td>
                                                <td>22.9%</td>
                                                <td>16.4%</td>
                                            </tr>
                                            <tr>
                                                <td>50</td>
                                                <td>25.2%</td>
                                                <td>18.9%</td>
                                            </tr>
                                            <tr>
                                                <td>55</td>
                                                <td>26.3%</td>
                                                <td>20.9%</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        </tbody>
                                    </table>
                                </div>
                                <br />                                يمكن استخدام هذه النتائج لفهم نسبة الدهون في الجسم الحالية والمطلوبة، وكذلك لتوجيه الجهود المستقبلية للتغذية واللياقة البدنية.
                                <br />                                <div className=' p-3 mb-2 bg-info text-black'>
                                    من الجدير بالملاحظة أن هذه الحاسبة تعتمد على تقديرات ومعادلات محددة، ولا تعد بديلاً عن استشارة الأطباء أو الخبراء المتخصصين في المجال. إذا كنت ترغب في تحديد الدهون في جسمك بدقة أو الحصول على مشورة شخصية، فمن الأفضل استشارة محترف ذو خبرة.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default BodyFatCalculator;
